// Parameter
export const STARTDATE = 'startDate';
export const ENDDATE = 'endDate';
export const TAG = 'category';
export const REGION = 'region';
